module.exports = {"610528001":"城关街道","610528101":"庄里镇","610528102":"张桥镇","610528103":"美原镇","610528104":"流曲镇","610528105":"淡村镇","610528107":"留古镇","610528108":"老庙镇","610528109":"薛镇","610528110":"到贤镇","610528111":"曹村镇","610528112":"宫里镇","610528113":"梅家坪镇","610528114":"刘集镇","610528115":"齐村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610528.json
// module id = 2621
// module chunks = 0